import { IconConverter } from 'icon-sdk-js/build/icon-sdk-js.web.min.js';
import { sha3_256 } from 'js-sha3';

/**
   * Create a hash object and hash message.
   * @param value The message you want to hash.
   */
export const hash = (value) => {
    return sha3_256.update(value).hex();
}

/**
 * Convert string, number or BigNumber value to hex string.
 * @param {string|number|BigNumber} value - the value.
 * @return {string} the value converted to hex string.
 */
export const toHex = (value) => {
    if (typeof value === "boolean") {
        return value?'0x1':'0x0';
    }
    return IconConverter.toHex(value);
}